module.exports = __webpack_public_path__ + "media/images/categories/headers/news-c2ad5b438d8acb5b159d076b1d458e85.jpg";